import { create } from "zustand";

interface IntakeFormState {
  isSaving: boolean;
  isFormValid: boolean;
  isSubmitting: boolean;
  setIsSaving: (isSaving: boolean) => void;
  setIsFormValid: (isValid: boolean) => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
}

export const useIntakeFormStore = create<IntakeFormState>((set) => ({
  isSaving: false,
  isFormValid: true,
  isSubmitting: false,
  setIsSaving: (isSaving) => set({ isSaving }),
  setIsFormValid: (isFormValid) => set({ isFormValid }),
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
}));
